import React, { useState, useEffect, useContext } from "react";
import ChildSidebar from "../Components/ChildSidebar";
import { SettingsData } from "../Data/Data";
import { Route, Routes } from "react-router-dom";
import Map_edit from "../Components/Settings/Map_edit";
import TadobaContext from "../Components/Context/TadobaContext";
const Settings = () => {
  const [data, setData] = useState(SettingsData);
  const api = useContext(TadobaContext);
  console.log(api.user.role.id);

  useEffect(() => {
    if (
      window.location.pathname.includes("settings") &&
      api.user.role.id === 3
    ) {
      const filteredData = data
        .filter((item) => item.title === "Geolocation Setup")
        .map((item) => ({ ...item, link: "./" }));
      setData(filteredData);
      console.log(filteredData);
    }
  }, []);
  return (
    <div className="settings">
      <ChildSidebar Data={data} />
      <div className="settings_Child">
        <Routes>
          {data.map((value, key) => {
            return (
              <Route
                path={"/" + value.link.substr(1)}
                element={value.element}
              />
            );
          })}
          <Route path="/map_setup/:map_id" element={<Map_edit />} />
        </Routes>
      </div>
    </div>
  );
};

export default Settings;
